<template>
  <div class="image-walll w-full h-full">
    <column-header class="mb-10px" :title="title" :showMore="data.showMore" @loadMore="loadMore" />
    <el-carousel
      :autoplay="false"
      arrow="always"
      indicator-position="none"
      class="bg-hex-$portalColumnBgColor h-[calc(100%-50px)]"
    >
      <el-carousel-item
        v-for="item in Math.ceil(list.length / (row * col))"
        :key="item"
        class="px-10px py-15px"
      >
        <div class="h-full relative">
          <el-image
            v-for="(imgItem, index) in getGroupList(item - 1)"
            :key="imgItem.id"
            :src="`${fileUrl}${imgItem.imageFile}`"
            :fit="data.imageFit || 'fill'"
            class="cursor-pointer"
            :style="{
              marginLeft: index % col === 0 ? '0px' : '40px',
              height: `calc(100% / ${row} - 8px * ${row - 1} / ${row})`,
              width: `calc(100% / ${col} - 40px * ${col - 1} / ${col})`,
            }"
            @click="toDetail(imgItem)"
          ></el-image>
          <template v-for="(imgItem, index) in getGroupList(item - 1)">
            <div
              v-if="index < col - 1"
              :key="index"
              class="bg-hex-fff h-full w-3px absolute top-0 py-15px"
              :style="{
                left: `calc((100% / ${col} - 40px * ${col - 1} / ${col}  + 40px) * ${index +
                  1} - 21.5px)`,
              }"
            >
              <div class="absolute top-4px left-[-2.5px]">
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px"></div>
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px mt-1px"></div>
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px mt-1px"></div>
              </div>
              <div class="absolute top-1/2 mt-[-5px] left-[-2.5px]">
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px"></div>
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px mt-1px"></div>
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px mt-1px"></div>
              </div>
              <div class="absolute bottom-4px left-[-2.5px]">
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px"></div>
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px mt-1px"></div>
                <div class="bg-hex-$portalPrimaryColor w-8px h-2.61px rounded-1px mt-1px"></div>
              </div>
            </div>
          </template>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
const columnHeader = () => {
  return import('./ColumnHeader')
}
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
  },
  components: {
    columnHeader,
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 1,
        total: 0,
      },
      dataSource: '',
      list: [],
      title: '专题',
      row: 1,
      col: 1,
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        window.open(
          `${window.location.origin}${window.location.hash ? '/#' : ''}${
            this.routerBase
          }/portal/homepage?columnId=${this.data.dataSource}`
        )
      }
    },
    getGroupList(index) {
      const num = this.row * this.col
      const startIndex = index * num
      return this.list.slice(startIndex, startIndex + num)
    },
    toDetail(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `${this.routerBase}/portal/homepage?columnId=${row.jumpColumn}`
        // row.skipMode === 1
        //   ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
        //   : this.$router.push(path)
        window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource != null && this.data.dataSource !== '') {
        this.page.pageSize = this.data.pageSize * this.col * this.row
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.getListData()
        }
      }
    },
    async getListData() {
      const params = {
        columnId: this.data.dataSource,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(this.page.pageNo, this.page.pageSize, params)
      })
      if (!err && res) {
        this.list = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.list.push(it) : ''
        })
        this.page.total = res.totalCount
      }
    },
  },
  created() {},
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          this.row = val.row || 1
          this.col = val.col || 1
          if (val.title) this.title = val.title
          if (
            val.dataSource !== this.dataSource ||
            val.pageSize !== this.page.pageSize ||
            val.row !== oldVal?.row ||
            val.col !== oldVal?.col
          ) {
            this.dataSource = val.dataSource
            this.page.pageSize = val.pageSize * this.row * this.col
            this.getTitle()
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.image-walll {
  &::v-deep .el-carousel {
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__arrow {
      width: 30px;
      height: 40px;
      border-radius: unset;
      background-color: rgba(0, 0, 0, 0.3);
      &:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
  }
}
</style>
